module.exports = __webpack_public_path__ + "img/arrow_right_orange.e6de9a74.svg";